import { ProjectRenderer } from '../ProjectRenderer';
import { Object3D } from 'three';
import { CreatorPost, PostType } from '@/types/creator';
import { SerializedPost, UserDataProp } from '../types';
import { CollidableObject } from './CollidableObject';
import { UUID } from '@/types/types';

export type CreatorPostData = Pick<
	CreatorPost,
	'id' | 'posY' | 'type' | 'isAdjustable' | 'linkedCreatorAccessoryId'
>;

export class Post extends CollidableObject {
	isAdjustable = true;
	type: PostType;

	constructor(
		renderer: ProjectRenderer,
		creatorPostData: CreatorPostData,
		object: Object3D
	) {
		super(
			renderer,
			{
				id: creatorPostData.id,
				posY: creatorPostData.posY,
				linkedObjectId: creatorPostData.linkedCreatorAccessoryId,
			},
			object
		);

		this.type = creatorPostData.type;

		this.setId(creatorPostData.id);

		if (this.type === PostType.MIDDLE) {
			object.visible = true;
			this.renderer.project.add(object);
		}
	}

	setId(id: UUID) {
		this.id = id;
		this.object.userData[UserDataProp.POST_ID] = id;

		this.object.traverse((child) => {
			child.userData[UserDataProp.POST_ID] = id;
		});
	}

	export(): SerializedPost {
		return {
			id: this.id,
			posY: this._posY,
			type: this.type,
			linkedCreatorAccessoryId: this.linkedObjectId,
			isAdjustable: this.isAdjustable,
		};
	}
}
